import { useMutation } from '@tanstack/react-query'

import { AxiosError } from 'axios'
import { ErrorHandling } from '../../../@types/ErrorHandling'
import {
  UpdateEntityDetailsClientRequest,
  UpdateEntityDetailsClientResponse,
} from '../../../@types/UpdateEntityDetails'
import { ENV } from '../../../Environment'
import { api } from '../../../Services/API'
import { useUpdateEntityDetailsStore } from '../../../Stores/useUpdateEntityDetailsStore'
import { API_ROUTES } from '../../../constants/apiRoutes'
import { useErrorRequest } from '../../useErrorRequest'
import { useGetAdditionalEntityDetails } from '../useGetAdditionalEntityDetails'

type PayloadProps = {
  payload: UpdateEntityDetailsClientRequest
  type: string
}

const headers = {
  'aip-company': ENV().CompanyAgeas,
}

const request = async (payload: PayloadProps) => {
  const response = await api.post<UpdateEntityDetailsClientResponse>(
    API_ROUTES.updateEntityDetails,
    payload,
    { headers },
  )

  return response.data
}

export const useUpdateEntityDetails = () => {
  const { setUpdateEntityDetails } = useUpdateEntityDetailsStore()
  const { mutate: mutateAdditionalDetails } = useGetAdditionalEntityDetails()
  const { handleErrorRequest } = useErrorRequest()

  return useMutation({
    mutationFn: (payload: PayloadProps) => request(payload.payload! as never),
    onSuccess(data, variables, context) {
      setUpdateEntityDetails(data)

      if (variables.type !== 'addresses') {
        mutateAdditionalDetails({ entityId: variables.payload.idEntity })
      }
    },
    onError(error: AxiosError<ErrorHandling[]>) {
      handleErrorRequest({ error })
    },
  })
}
